const SUGGESTIONS = [
  "Add a margin column to this sheet",
  "Show me the row with the highest value",
  "Summarize this dataset in a new tab",
  "Explain what's happening in row 5",
];

export function EmptyState({ onSelect }: { onSelect: (prompt: string) => void }) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 px-4 py-8 text-center">
      <p className="text-[15px] font-semibold text-[var(--text-primary)]">
        What would you like to do?
      </p>
      <p className="text-[13px] text-[var(--text-muted)]">
        Ask a question or pick a suggestion to get started.
      </p>
      <div className="flex w-full max-w-[260px] flex-col gap-2">
        {SUGGESTIONS.map((s) => (
          <button
            key={s}
            onClick={() => onSelect(s)}
            className="rounded-xl border border-[var(--border-accent)] bg-[var(--surface-overlay)] px-3 py-2 text-left text-[13px] text-[var(--text-secondary)] transition-colors hover:border-[var(--brand-accent)] hover:text-[var(--text-primary)]"
          >
            {s}
          </button>
        ))}
      </div>
    </div>
  );
}
